import { css } from '@/styled-system/css';

export const managerName = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const companyName = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginBottom: 'xs',
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxTeal500',
  marginBottom: '2x',
});

export const verifiedIcon = css({
  width: '16px',
  height: '16px',
});

export const officeHours = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const officeHoursLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const officeHoursLine = css({
  lineHeight: '1.6',
  color: 'hpxBlue500',
});

export const managerIcon = css({
  width: '16px',
  height: '16px',
});

export const desktopContactSection = css({
  display: 'block',
  marginBottom: '2x',
});

export const desktopContactLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontWeight: '700',
  fontSize: 'sm',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const desktopContactIcon = css({
  display: 'flex',
  color: 'hpxBlue600',
  '& svg': {
    width: '16px',
    height: '16px',
  },
});

export const desktopContactPhone = css({
  display: 'block',
  fontSize: 'sm',
  color: 'hpxTeal500',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const footerActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
  marginTop: '2x',
});

export const messageButtonWrapper = css({
  flex: 1,
  md: {
    maxWidth: '50%',
  },
});

export const callButtonWrapper = css({
  flex: 1,
  display: 'flex',
  md: {
    display: 'none',
  },
});
